import React from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon } from '../../../_components'


export default function Location( { values, handleChange, handleBlur, data } ) {
  return (
    <Panel label="Location">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-3">
            <SelectFieldIcon 
                name="district"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.district}
                label="District"
                required={true}
                question="District"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : true}
                options={data.districts.map( district => ( { id: district.id, label: district.label, value: district.value } ) )} />

            <TextFieldIcon 
                name="subcounty"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.subcounty}
                label="Subcounty"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Subcounty"/>

            <TextFieldIcon 
                name="parish"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.parish}
                label="Parish"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Parish" />

            <TextFieldIcon 
                name="village"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.village}
                label="Village"
                required={true}
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                question="Village"/>
        </div>
    </Panel>
  )
}
